import { defineMessages } from 'react-intl';

export const pricingPoliciesMessages = defineMessages({
    pricingPolicies: {
        id: 'pricing-policies',
        defaultMessage: 'Pricing policies',
    },
    policies: {
        id: 'policies',
        defaultMessage: 'Policies',
    },
    policy: {
        id: 'policy',
        defaultMessage: 'Policy',
    },
    amount: {
        id: 'amount',
        defaultMessage: 'Amount',
    },
    pre: {
        id: 'pre',
        defaultMessage: 'Pre',
    },
    post: {
        id: 'post',
        defaultMessage: 'Post',
    },
    paymentType: {
        id: 'payment-type',
        defaultMessage: 'Payment type',
    },
    pricingModel: {
        id: 'pricing-model',
        defaultMessage: 'Pricing model',
    },
    pricingModelFlat: {
        id: 'pricing-model-flat',
        defaultMessage: 'Flat',
    },
    pricingModelPerUnit: {
        id: 'pricing-model-per-unit',
        defaultMessage: 'Per unit',
    },
    taxReason: {
        id: 'tax-reason',
        defaultMessage: 'Tax reason',
    },
    createServicePlanPricingPolicySuccess: {
        id: 'create-service-plan-pricing-policy-success',
        defaultMessage: 'Pricing policy created',
    },
    createServicePlanPricingPolicySuccessDescription: {
        id: 'create-service-plan-pricing-policy-success-description',
        defaultMessage: 'A service plan pricing policy has been successfully created.',
    },
    addServicePlanPricingPolicySubtitle: {
        id: 'add-service-plan-pricing-policy-subtitle',
        defaultMessage: 'Create a new service plan pricing policy',
    },
    deleteServicePlanPricingPolicy: {
        id: 'delete-service-plan-pricing-policy',
        defaultMessage: 'Delete pricing policy',
    },
    deleteServicePlanPricingPolicySuccess: {
        id: 'delete-service-plan-pricing-policy-success',
        defaultMessage: 'Pricing policy deleted',
    },
    deleteServicePlanPricingPolicySuccessDescription: {
        id: 'delete-service-plan-pricing-policy-success-description',
        defaultMessage: 'The pricing policy has been successfully deleted.',
    },
    confirmDeleteServicePlanPricingPolicy: {
        id: 'confirm-delete-service-plan-pricing-policy',
        defaultMessage: 'Are you sure you want to delete this service plan pricing policy? This action cannot be undone.',
    },
    deleteServicePlanPricingPolicySubtitle: {
        id: 'delete-service-plan-pricing-policy-subtitle',
        defaultMessage: 'Permanently delete service plan pricing policy',
    },
    editServicePlanPricingPolicySubtitle: {
        id: 'edit-service-plan-pricing-policy-subtitle',
        defaultMessage: 'Edit pricing policy',
    },
    updateServicePlanPricingPolicySuccess: {
        id: 'update-service-plan-pricing-policy-success',
        defaultMessage: 'Pricing policy updated',
    },
    updateServicePlanPricingPolicySuccessDescription: {
        id: 'update-service-plan-pricing-policy-success-description',
        defaultMessage: 'Service plan pricing policy has been successfully updated.',
    },
})